export const defaultValue = <T, U>(value: T, fallback: U) => value ?? fallback;

export { useGridContainerHeight } from "./useGridContainerHeight";

export default {};
